<template>
  <div class="virtual-tour-modal">
    <div class="virtual-tour-modal__mask"></div>
    <div class="virtual-tour-modal__inner">
      <iframe class="touch" id="virtual-tour" :src="isMatterport ? url + matterportParams : url" frameborder="0"></iframe>
      <div class="iframe-mask iframe-mask--left"></div>
      <div class="iframe-mask iframe-mask--right"></div>
      <div class="iframe-close touch" @click="close">
        <fa :icon="['fas', 'times']" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['url'],

  data () {
    return {
      isLoaded: false,
      matterportParams: '&brand=0&help=0&hl=0&dh=0&gt=0&hr=0&mt=0&pin=0&portal=0&f=0&title=0&vr=0&nozoom=1&noshare=1'
    }
  },

  computed: {
    isMatterport () {
      return this.url.includes('matterport')
    }
  },

  watch: {
    $route() {
      this.close()
    }
  },

  methods: {
    close () {
      this.$store.commit('property/SET_ACTIVE_VIRTUAL_TOUR_URL', '')
      this.$store.state.videoWallIframePlaying = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";
@import "@/styles/_buttons.scss";

.virtual-tour-modal {
  bottom: 10rem;
  left: 0;
  pointer-events: auto;
  position: absolute;
  right: 32.5rem;
  top: 0;
  z-index: 100;

  &__mask {
    background: rgba(0, 0, 0, 0.6);
    height: 100%;
    pointer-events: auto;
    position: absolute;
    width: 100%;
  }

  &__inner {
    background: #fff;
    border-radius: .5rem;
    bottom: 10rem;
    display: flex;
    flex-direction: column;
    height: 70rem;
    left: 50%;
    overflow: hidden;
    pointer-events: auto;
    position: absolute;
    transform: translateX(-50%);
    width: 120rem;
  }

  iframe {
    height: 100%;
    width: 100%;
  }

  .iframe-mask {
    // background: rgba(255, 255, 255, 0.8);
    border-radius: 1rem 0 0 0;
    bottom: 0;
    height: 56px;
    position: absolute;
    
    width: 170px;
    pointer-events: auto;
    z-index: 10;

    &--left {
      left: 0;
    }

    &--right {
      right: 0;
    }
  }

  .iframe-close {
    background: #4d555b;
    border-radius: 50%;
    bottom: 2rem;
    box-shadow: 0.15em 0.25em 0.35em rgba(0, 0, 0, 0.45);
    height: 5rem;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    width: 5rem;
    z-index: 10;

    svg {
      font-size: 2.6rem;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

</style>